module.exports = __webpack_public_path__ + "static/media/AverilOffline.294fc819.jpg";